import { PdfData } from "./types";

const IncidentData: PdfData = {
  title: "Incidents",
  description: {
    i18nKey: "incidents_description",
    label: "Please report here accidents related to the child",
  },
  fields: [
    {
      name: "eventDate",
      label: "Event date",
    },
    {
      name: "eventTime",
      label: "Event time",
    },
    {
      name: "eventMoment",
      label: "Event moment",
    },
    {
      name: "eventLocation",
      label: "Event location",
    },
    {
      name: "ageOfChild",
      label: "Age of the child involved in the incident",
    },
    {
      name: "precisionTypeEvent",
      label: "Precision on the type of event",
    },
    {
      name: "eventDescription",
      label: "Event Description (factual & taken care of elements)",
    },
    {
      name: "consequences",
      label: "Consequences",
    },
    {
      name: "emsContacted",
      label: "EMS contacted",
    },
    {
      name: "hospitalization",
      label: "Hospitalization (including emergency room)",
    },
    {
      name: "childAbsence",
      label: "Child absence",
    },
    {
      name: "aftercare",
      label: "Aftercare",
    },
    {
      name: "securityLevel",
      label: "Severity level",
    },
    {
      name: "parentsBeenInformed",
      label: "Have the parents been informed?",
    },
    {
      name: "insuranceBeNotified",
      label: "Should the Insurance be notified?",
    },
    {
      name: "insuranceBeenNotified",
      label: "Has the Insurance been notified?",
    },
    {
      name: "localAuthorityBeNotified",
      label: "Should the local authority be notified?",
    },
    {
      name: "localAuthorityBeenNotified",
      label: "Has the local authority been notified?",
    },
    {
      name: "supervisionRateRespected",
      label:
        "Was the supervision rate respected at the time of the accident in the reception area concerned?",
    },
    {
      name: "usualTeam",
      label: "Usual team in the reception area?",
    },
    {
      name: "professionalNames",
      label:
        "Name of all professionals present in the unit where the event took place",
    },
    {
      name: "immediateCorrectiveActions",
      label: "Immediate corrective actions",
    },
    {
      name: "riskRelatedEvent",
      label: "Risks related to the event",
    },
    {
      name: "eventAvoidedSafer",
      label: "Could the event have been avoided with safer equipment?",
    },
    {
      name: "recurrence",
      label: "Recurrence",
    },
  ],
};

export default IncidentData;
